import React from "react"

const Button = (props) => {

    const {
        id,
        defaultClassName="font-rg text-6 text-white bg-primary white rounded-lg w-full",
        defaultStyle = { lineHeight: '19px', height: '60px' },
        className='',
        style,
        onClick,
        disabled,
        children
    } = props;


    return (
        <button 
        id={id} 
        className={`${defaultClassName} ${className}`} 
        style={{...defaultStyle, ...style}} 
        disabled={disabled} 
        onClick={() => {
            if (onClick) onClick();
        }}>
            {children}
        </button>
    )

}

export default Button